<script>

import { useToast } from "vue-toastification";
import { formatISO } from 'date-fns'

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap

import LoadingScreen from '@/components/General/LoadingScreen'
import LoadingButton from '@/components/General/LoadingButton'
import Alert from '@/components/General/Alert'

import Datepicker from 'vue3-date-time-picker';
import 'vue3-date-time-picker/dist/main.css'

//components
import AuditLogs from '@/components/Core/AuditLog/AuditLogs.vue'

//general functions
import MixinGeneralFunct from '@/mixins/GeneralFunctions';
import { defineComponent } from 'vue'

//data
import { getStateOptions, getActivationOptions } from '@/services/serviceCommon';
import { getAccessRightsOptions } from '@/services/serviceAccessRight';
import { getUser, unlockUser, saveUser, createUser, checkDuplicityUser, getTypeOptions, getMultiOptions } from '@/services/serviceUser';
import { getCityOptions, getRegionOptions, getCountryOptions, getDistrictsOptions } from '@/services/serviceArea';

//utils
import { zistiDiff } from '@/utils/auditLogs';

export default defineComponent ({
	setup() {
		const toast = useToast();
		return { toast }
	},
	name: 'UserEdit',
	mixins: [ MixinGeneralFunct ],
	components: {
		Datepicker
		,LoadingScreen
		,LoadingButton
		,Alert
		,AuditLogs
	},
	props: {'userId': String, 'auth':Object, 'secData':Object, 'params':Object, 'modalObject': Object, 'modalId': String},
	emits: ["changeRecord"],
	data() {
		return {
			metaData: [],
			
			isLoading:true,
			isSending:false,
		
			valid_upOptions: {
				locale: 'sk',
				format: 'd.M.YYYY HH:mm',
				//useCurrent: true,
				//showClear: true,
				//showClose: true,
			},
			
			valid_downOptions: {
				locale: 'sk',
				format: 'd.M.YYYY HH:mm',
				useCurrent: true,
				showClear: true,
				showClose: true,
			},
			
			optionsAccessLevels: [],
			optionsActivationStates:[],
			optionsTypes:[],
			optionsStates:[],
			optionsMultiLogin:[],
			
			optionsCountries:[],
			optionsRegions:[],
			optionsDistricts:[],
			optionsCities:[],
						
			//form
			data:{},
			oldData:{},

			//auditLogs
			
			selectedDate:'',
			selectedDocId:'',

			sameRecords:[],

			//tabs
			tab1:'',
			tab2:'',
			tab3:'',

			
		}
	},
	
	mounted:function(){
	
		this.tab1 = `tab${this.getRandomInt(99999999999)}`;
		this.tab2 = `tab${this.getRandomInt(99999999999)}`;
		this.tab3 = `tab${this.getRandomInt(99999999999)}`;

		
	},
	
	methods: {
		
		// load data form
		loadDefaultValues:function(){
			
			this.isLoading=true
			
			getUser({userId:this.userId}).then(response => {
				if(!response.statusText){
					this.isLoading=false
					this.metaData = response.metaData;
					this.data = response.data;
					this.oldData = response.oldData;

					if(this.data.valid_up){
						this.data.valid_up_view = this.data.valid_up;
					}
					if(this.data.valid_down){
						this.data.valid_down_view = this.data.valid_down;
					}

					if(this.oldData.valid_up){
						this.oldData.valid_up = formatISO(new Date(this.oldData.valid_up), 'yyyy-MM-dd HH:mm:ss');
					}
					if(this.oldData.valid_down){
						this.oldData.valid_down = formatISO(new Date(this.oldData.valid_down), 'yyyy-MM-dd HH:mm:ss');
					}

					this.sameRecords = '';
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

			getAccessRightsOptions().then(response => {
				if(!response.statusText){
					this.optionsAccessLevels = response.optionsAccessLevels;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

			getStateOptions().then(response => {
				if(!response.statusText){
					this.optionsStates = response.optionsStates;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

			getActivationOptions().then(response => {
				if(!response.statusText){
					this.optionsActivationStates = response.optionsActivationStates;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

			getTypeOptions().then(response => {
				if(!response.statusText){
					this.optionsTypes = response.optionsTypes;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

			getMultiOptions().then(response => {
				if(!response.statusText){
					this.optionsMultiLogin = response.optionsMultiLogin;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

			getCountryOptions().then(response => {
				if(!response.statusText){
					this.optionsCountries = response.optionsCountries;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

			getRegionOptions().then(response => {
				if(!response.statusText){
					this.optionsRegions = response.optionsRegions;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

			getDistrictsOptions().then(response => {
				if(!response.statusText){
					this.optionsDistricts = response.optionsDistricts;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

			getCityOptions().then(response => {
				if(!response.statusText){
					this.optionsCities = response.optionsCities;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

			
		},
		
		
		
		// check duplicity person
		onCheckDuplicityUser:function(){
			checkDuplicityUser(this.data.email).then(response => {
				if(!response.statusText){
					this.sameRecords = response.sameRecords;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});
		},
		
		checkSave:function(){
			//console.log(this.data.surname);
			var emailPattern = /\S+@\S+\.\S+/;
			
			if(!this.data.surname){this.data.surnameError = true;}else{this.data.surnameError = false;}
			if(this.data.email){
				if(!this.data.email.match(emailPattern)){this.data.emailError = true;}else{this.data.emailError = false;}
			}else{
				{this.data.emailError = true;}
			}
			if(!this.data.active){this.data.activeError = true;}else{this.data.activeError = false;}
			if(!this.data.type){this.data.typeError = true;}else{this.data.typeError = false;}
			if(!this.data.state){this.data.stateError = true;}else{this.data.stateError = false;}
			if(!this.data.color){this.data.colorError = true;}else{this.data.colorError = false;}
			if(!this.data.valid_up_view){this.data.valid_upError = true;}else{this.data.valid_upError = false;}
			//if(!this.data.valid_down){this.data.valid_downError = true;}else{this.data.valid_downError = false;}
			if(this.data.valid_down && this.data.valid_down <= this.data.valid_up){this.data.valid_downError = true;}else{this.data.valid_downError = false;}
			if(!this.data.access){this.data.accessError = true;}else{this.data.accessError = false;}
			if(!this.data.multi){this.data.multiError = true;}else{this.data.multiError = false;}
			
			if(!this.data.surnameError && !this.data.emailError && !this.data.activeError && !this.data.typeError && !this.data.stateError && !this.data.colorError && !this.data.valid_upError && !this.data.accessError && !this.data.multiError){
				return true;
			}else{
				this.toast.warning(this.$t('msgCore.fillInAllData'));
				return false;
			}
		},	
		
		onClose:function(){
			if(this.userId!='null'){
				unlockUser({userId:this.userId}).then(response => {
					if(!response.statusText){
						this.isLoading=false
						if(response.resCode==1){
							this.$emit('changeRecord', '')
							this.modalObject.hide();
						}
					}else{
						this.isLoading=false
						this.toast.error(`${response.statusText} ${response.status}`);
					}
				});
			}else{
				this.$emit('changeRecord', '')
				this.modalObject.hide();
			}
		},

		
		
		onSave:function(){
			
			if(this.checkSave()){
				this.data.valid_up = formatISO(new Date(this.data.valid_up_view), 'yyyy-MM-dd HH:mm:ss');
				this.data.valid_down = this.data.valid_down_view ? formatISO(new Date(this.data.valid_down_view), 'yyyy-MM-dd HH:mm:ss') : null;
				if(this.userId!='null'){		
					this.isSending=true
					saveUser({data:this.data}).then(response => {
						if(!response.statusText){
							this.isSending=false
							if(response.resCode==1){
								zistiDiff(this.oldData,this.data,this.userId,1);
								this.toast.success(this.$t('msgCore.dataWasSaved'));
								this.$emit('changeRecord', '')
								this.data = [];
								this.modalObject.hide();
							}else if(response.resCode==0){
								this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
							}else if(response.resCode==2){
								this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
							}else if(response.resCode==3){
								this.toast.error(this.$t('msgCore.accessDenied'));
							}
						}else{
							this.isSending=false
							this.toast.error(`${response.statusText} ${response.status}`);
						}
					});
				}else{
					createUser({data:this.data}).then(response => {
						if(!response.statusText){
							this.isSending=false
							if(response.resCode==1){
								zistiDiff(this.oldData,this.data);
								this.toast.success(this.$t('msgCore.dataWasSaved'));
								this.$emit('changeRecord', '')
								this.data = [];
								this.modalObject.hide();
							}else if(response.resCode==0){
								this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
							}else if(response.resCode==2){
								this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
							}else if(response.resCode==3){
								this.toast.error(this.$t('msgCore.accessDenied'));
							}
						}else{
							this.isSending=false
							this.toast.error(`${response.statusText} ${response.status}`);
						}
					});
				}
			}
			
		}
	},
	
	watch: {
		userId() {
			if(this.userId){
				this.loadDefaultValues();
			}
			
		},/* !!!!!! tomu to daj spravy zapis pre objekt xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx POOOOOOOOOOOOOOOOOzor
		data.email() {
			this.onCheckDuplicityUser();
		}*/
	},

	computed:{
		
	},
	
})

</script>

<template>
	<div>
		<div class="modal fade" :id="modalId" tabindex="-1" >
			<div class="modal-dialog modal-xl modal-dialog-scrollable">
				<LoadingScreen :isLoading="isLoading"></LoadingScreen>
				<div class="modal-content">
					<div class="modal-header">
						<h6 class="modal-title">{{ $t('msgCore.User') }} <span v-if="!data.isNewRecord"><b>{{ data.name }} {{ data.surname }}</b> id: {{data.id}}</span></h6>
					</div>
			
							<div v-if="metaData.modulAccess && (auth.usersNew || auth.usersEdit)" class="modal-body">
								
								<div class="row">
									<div class="col-12">
										<div v-if="data.isCheckedOut && secData.userId != data.isCheckedOutId" class="angle">
											<span class="angle-inner" :class="{'angle-warning':data.isCheckedOut}"><i class="fa" :class="{'angle-warning':data.isCheckedOut, 'fa-exclamation-triangle':data.isCheckedOut}" aria-hidden="true"></i> {{$t('msgCore.Edited')}} </span >
											
											<span v-if="data.isCheckedOut" class="personCircle v-center" v-bind:style="{background:data.isCheckedOutColor}" v-bind:title="data.isCheckedOutName+', '+data.isCheckedOutDate">{{ data.isCheckedOutLetterName+''+data.isCheckedOutLetterSurname }}</span>
										</div>
									</div>
								</div>
								
								<div class="row">
									<div class="col-12">
									
									<ul class="nav nav-tabs" role="tablist">
					
										<li class="nav-item" role="presentation">
											<a class="nav-link active" :id="`${tab1}-tab`" data-bs-toggle="tab" :data-bs-target="`#${tab1}`" role="tab" :aria-controls="tab1" aria-selected="true">{{ $t('msgCore.basicData') }}</a>
										</li>
										
										<li v-if="params.showUsersExtendedData"  class="nav-item" role="presentation">
											<a class="nav-link" :id="`${tab2}-tab`" data-bs-toggle="tab" :data-bs-target="`#${tab2}`" role="tab" :aria-controls="tab2" aria-selected="false">{{ $t('msgCore.extendedData') }}</a>
										</li>

										<li class="nav-item" role="presentation">
											<a class="nav-link" :id="`${tab3}-tab`" data-bs-toggle="tab" :data-bs-target="`#${tab3}`" role="tab" :aria-controls="tab3" aria-selected="false">{{ $t('msgCore.AuditLogs') }}</a>
										</li>
															
									</ul>
							
									<div class="tab-content" id="myTabContent">
							
										<div :id="`${tab1}`" class="tab-pane active" role="tabpanel" :aria-labelledby="`${tab1}-tab`">
										
											<div class="row">
												<div class="col-md-8 col-12">
														
													<div class="row">
														<div class="col-md-2 col-12">
															<label><b>{{ $t('msgCore.TitleBefore') }}</b> </label>
															<input type="text" class="form-control form-control-sm" v-model="data.titleBefore" >
														</div>
														
														<div class="col-md-3 col-12">
															<label><b>{{ $t('msgCore.Name') }}</b> </label>
															<input type="text" class="form-control form-control-sm" v-model="data.name" >
														</div>
														
														<div class="col-md-5 col-12">
															<label :class="{'text-danger':data.surnameError}"><b>{{ $t('msgCore.Surname') }}</b> </label>
															<input type="text" class="form-control form-control-sm" :class="{'is-invalid':data.surnameError}" v-on:change="checkSave()" v-model="data.surname" >
															<div v-show="data.surnameError" class="error-input"><span class="badge badge-pill badge-danger">{{$t('msgCore.fillIn')}}</span></div>
														</div>
														
														<div class="col-md-2 col-12">
															<label><b>{{ $t('msgCore.TitleAfter') }}</b> </label>
															<input type="text" class="form-control form-control-sm" v-model="data.titleAfter" >
														</div>
														
													</div>													
														
														
														
													<div class="row">	
														<div class="col-md-8 col-12">
															<label :class="{'text-danger':data.emailError}"><b>{{ $t('msgCore.Email') }}</b> </label>
															<input type="text" class="form-control form-control-sm" :class="{'is-invalid':data.emailError}" v-on:change="checkSave();onCheckDuplicityUser();" v-model="data.email" >
															<div v-show="data.emailError" class="error-input"><span class="badge badge-pill badge-danger">{{$t('msgCore.fillIn')}}</span></div>
														</div>
														
														<div class="col-md-4 col-12">
															<label><b>{{ $t('msgCore.Username') }}</b> </label>
															<input type="text" class="form-control form-control-sm" v-model="data.username" >
														</div>
													</div>	
													
													
													<div v-if="sameRecords.length>0" class="row">
														<div class="col-12">
															<label><i class="fa fa-exclamation-triangle text-danger"></i> {{ $t('msgCore.zhodneZaznamy') }}</label>
															<div class="table-responsive">
																<table class="table table-hover table-sm">
																	<tr v-for="(item) in sameRecords" :key="item">
																		<td>{{item.id}}</td>
																		<td>{{item.name}}</td>
																		<td>{{item.surname}}</td>
																		<td>{{item.email}}</td>
																	</tr>
																</table>
															</div>
														</div>
													</div>
														
														
													<div class="row">	
														<div class="col-md-6 col-12">
															<label :class="{'text-danger':data.valid_upError}"><b>{{ $t('msgCore.Valid_up') }}</b> </label>
															
															<Datepicker v-model="data.valid_up_view" format="d.M.yyyy HH:mm" :locale="$i18n.locale"  @update:modelValue="checkSave()" :cancelText="$t('msgCore.Cancel')" :selectText="$t('msgCore.Select')" :class="{'is-invalid':data.valid_upError}"></Datepicker>
															<div v-show="data.valid_upError" class="error-input"><span class="badge badge-pill badge-danger">{{$t('msgCore.fillIn')}}</span></div>
														</div>
														
														<div class="col-md-6 col-12">
															<label><b>{{ $t('msgCore.Valid_down') }}</b> </label>
															<Datepicker v-model="data.valid_down_view" format="d.M.yyyy HH:mm" :locale="$i18n.locale"  :cancelText="$t('msgCore.Cancel')" :selectText="$t('msgCore.Select')" ></Datepicker>
															
														</div>
													</div>
													
													<div class="row">	
														<div class="col-md-4 col-12">
															<label :class="{'text-danger':data.colorError}"><b>{{ $t('msgCore.Color') }}</b> </label>
															<input type="color" class="form-control form-control-sm" :class="{'is-invalid':data.colorError}" v-on:change="checkSave()" v-model="data.color" >
															<div v-show="data.colorError" class="error-input"><span class="badge badge-pill badge-danger">{{$t('msgCore.fillIn')}}</span></div>
														</div>
														
														
														<div class="col-md-4 col-12">
															<label :class="{'text-danger':data.activeError}"><b>{{ $t('msgCore.Activation') }}</b></label>
															
															<div  v-for="(option) in optionsActivationStates" :key="option" class="form-check" :class="{'disabled':!auth.usersChangeStateActive}">
																<label class="form-check-label">
																	<input :disabled="!auth.usersChangeStateActive" class="form-check-input" type="radio" name="optionsActivationStates"  v-model='data.active' v-on:change="checkSave()" :value="option.value">
																	{{ $t('msgCore.'+option.title) }}
																	<span class="circle">
																		<span class="check"></span>
																	</span>
																</label>
															</div>
															
															<div v-show="data.activeError" class="error-input"><span class="badge badge-pill badge-danger">{{$t('msgCore.selectState')}}</span></div>
														</div>
														
														<div class="col-md-4 col-12">
															<label :class="{'text-danger':data.typeError}"><b>{{ $t('msgCore.Type') }}</b></label>
															
															<div  v-for="(option) in optionsTypes"  :key="option" class="form-check" :class="{'disabled':!auth.usersChangeStateActive}">
																<label class="form-check-label">
																	<input :disabled="!auth.usersChangeStateActive" class="form-check-input" type="radio" name="optionsTypes"  v-model='data.type' v-on:change="checkSave()" :value="option.value">
																	{{ $t('msgCore.'+option.title) }}
																	<span class="circle">
																		<span class="check"></span>
																	</span>
																</label>
															</div>
															
															<div v-show="data.typeError" class="error-input"><span class="badge badge-pill badge-danger">{{$t('msgCore.selectType')}}</span></div>
														</div>
													</div>	
											
												</div>
												
												<div class="col-md-4 col-12 form-control-system-data">
													<div class="row">
													
														<div class="col-12">
															<label :class="{'text-danger':data.accessError}"><b>{{ $t('msgCore.AccessLevel') }}</b></label>
																												
															<select v-model='data.access' :disabled="!auth.usersChangeAccessLevel" class="form-control form-control-sm " :class="{'is-invalid':data.accessError}" v-on:change="checkSave()">
																<option value="">{{ $t('msgCore.selectLevel') }}</option>
																<option v-for="(option) in optionsAccessLevels" :key="option" :value="option.value">{{ option.title }}</option>
															</select>
															<div v-show="data.accessError" class="error-input"><span class="badge badge-pill badge-danger">{{$t('msgCore.selectLevel')}}</span></div>
														</div>
														
														<div class="col-12">
															<label :class="{'text-danger':data.stateError}"><b>{{ $t('msgCore.State') }}</b></label>
															
															
															<div  v-for="(option) in optionsStates" :key="option" class="form-check">
																<label class="form-check-label">
																	<input class="form-check-input" type="radio" name="optionsStates"  v-model='data.state' v-on:change="checkSave()" :value="option.value">
																	{{ $t('msgCore.'+option.title) }}
																	<span class="circle">
																		<span class="check"></span>
																	</span>
																</label>
															</div>
															<div v-show="data.stateError" class="error-input"><span class="badge badge-pill badge-danger">{{$t('msgCore.selectState')}}</span></div>
														</div>
														
														<div class="col-12">
															<label :class="{'text-danger':data.multiError}"><b>{{ $t('msgCore.MultiLogin') }}</b></label>

															<select v-model='data.multi' :disabled="!data.isAllowedSetMultiLogin" class="form-control form-control-sm " :class="{'is-invalid':data.multiError}" v-on:change="checkSave()">
																<option value="">{{ $t('msgCore.selectLevel') }}</option>
																<option v-for="(option, ) in optionsMultiLogin" :key="option" :value="option.value">{{ option.title }}</option>
															</select>
															<div v-show="data.multiError" class="error-input"><span class="badge badge-pill badge-danger">{{$t('msgCore.selectType')}}</span></div>
														</div>
														
													</div>
												</div>
												
											</div>
										</div>
										
										
										<div v-if="params.showUsersExtendedData" :id="`${tab2}`" class="tab-pane" role="tabpanel" :aria-labelledby="`${tab2}-tab`">
											
											<div class="row">
												<div class="col-12">
													
													<div class="row">
														
														<div class="col-md-3 col-12">
															<label><b>{{ $t('msgCore.Country') }}</b> </label>
															
															<select v-model='data.country' class="form-control form-control-sm ">
																<option value="">{{ $t('msgCore.selectCountry') }}</option>
																<option v-for="(option, ) in optionsCountries" :key="option" :value="option.value">{{ option.title }}</option>
															</select>
														</div>
														
														<div class="col-md-3 col-12">
															<label><b>{{ $t('msgCore.Region') }}</b> </label>
															
															<select v-model='data.region' class="form-control form-control-sm ">
																<option value="">{{ $t('msgCore.selectRegion') }}</option>
																<option v-for="(option, ) in optionsRegions" :key="option" :value="option.value">{{ option.title }}</option>
															</select>
														</div>
														
														<div class="col-md-3 col-12">
															<label><b>{{ $t('msgCore.District') }}</b> </label>
															
															<select v-model='data.district' class="form-control form-control-sm ">
																<option value="">{{ $t('msgCore.selectDistrict') }}</option>
																<option v-for="(option, ) in optionsDistricts"  :key="option" :value="option.value">{{ option.title }}</option>
															</select>
														</div>
														
														<div class="col-md-3 col-12">
															<label><b>{{ $t('msgCore.City') }}</b> </label>
															
															<select v-model='data.city' class="form-control form-control-sm ">
																<option value="">{{ $t('msgCore.selectCity') }}</option>
																<option v-for="(option, ) in optionsCities" :key="option" :value="option.value">{{ option.title }}</option>
															</select>
														</div>
														
													</div>
													
													
													<div class="row">
																																			
														<div class="col-md-4 col-12">
															<label><b>{{ $t('msgCore.Phone') }}</b> </label>
															<input type="text" class="form-control form-control-sm" v-model="data.phone" >
														</div>
														
														<div class="col-md-4 col-12">
															<label><b>{{ $t('msgCore.Street') }}</b> </label>
															<input type="text" class="form-control form-control-sm" v-model="data.street" >
														</div>
													
													</div>
												</div>
											</div>	
												
										</div>

										<div :id="`${tab3}`" class="tab-pane" role="tabpanel" :aria-labelledby="`${tab3}-tab`">
											<div>
												<AuditLogs :auth="auth" :secData="secData" :currentDoc="data" typeId="1" :docId="String(userId)" ></AuditLogs>
											</div>
										</div>
										
										
										
									</div>
									
									</div>
								</div>	
									
							</div>
							
							<div v-else class="modal-body">
								<div class="row">
									<div class="col-12 mt-3">
										<Alert type="warning" :label="$t('msgCore.accessDenied')" />
									</div>
								</div>
							</div>
							
							<div class="modal-footer">
							
								<div class="btn-group">
									<button type="button" v-on:click="onClose()" class="btn btn-default btn-sm">{{ $t('msgCore.btnClose') }}</button>
									
									
									<LoadingButton :isDisabled="((!auth.usersEdit) || (!auth.usersNew) || isSending || !metaData.modulAccess)" :isSending="isSending" @onClick="onSave" :label="'msgCore.btnSave'" color="warning"></LoadingButton>
								</div>	
								
							</div>
						
				
				</div>

			</div>
			
		</div>

		
		
	</div>
</template>


